export const ROLE_KEPALA_RUANGAN = "Kepala Ruangan";
export const ROLE_ADMIN = "Admin";
export const ROLE_USER = "User";
export const ROLE_PENGAWAS = "Pengawas";

export const MANAGEMENT_ROLES = [ROLE_KEPALA_RUANGAN, ROLE_ADMIN];
export const BARANG_KELUAR_ROLES = [ROLE_KEPALA_RUANGAN, ROLE_ADMIN, ROLE_USER];
export const SUPPLIER_PAGE_ROLES = [ROLE_KEPALA_RUANGAN, ROLE_PENGAWAS];
export const SUPPLIER_MANAGE_ROLES = [ROLE_KEPALA_RUANGAN];
export const REPORT_PAGE_ROLES = [ROLE_KEPALA_RUANGAN, ROLE_PENGAWAS];
export const MODAL_PAGE_ROLES = [ROLE_KEPALA_RUANGAN, ROLE_PENGAWAS];
export const MODAL_MANAGE_ROLES = [ROLE_KEPALA_RUANGAN];

export const getDefaultRouteForRole = (role) => {
  if (role === ROLE_PENGAWAS) {
    return "/laporan";
  }

  if (role === ROLE_ADMIN) {
    return "/master-barang";
  }

  if (role === ROLE_USER) {
    return "/barang-keluar";
  }

  if (role) {
    return "/dashboard";
  }

  return "/login";
};
